import React from "react";
import { Badge, Pane, Strong, Text, EditIcon } from "evergreen-ui";
import { getCurrency, getFormattedTime } from "../util";

const PriceSlotsPane = (props) => {
	const { pricingType, pricingDetails, editPrice, isShown } = props;

	const pricingTypeList =
		pricingType === "special"
			? Object.keys(pricingDetails["pricing"][pricingType])
			: pricingDetails["pricing"][pricingType];

	return (
		<Pane marginBottom={20} border={"default"} elevation={1}>
			<Pane
				background={"tint2"}
				height={30}
				display={"flex"}
				justifyContent={"center"}
				alignItems={"center"}
				borderBottom={"default"}
			>
				<Strong>{pricingType.toUpperCase()}</Strong>
			</Pane>
			<Pane display={"flex"} flexDirection={"column"}>
				{pricingTypeList.map((pricing, index) => (
					<Pane
						key={index}
						borderBottom={
							index !== pricingTypeList.length - 1 ? "default" : null
						}
					>
						{pricingType !== "holiday" && (
							<Pane
								display={"flex"}
								justifyContent={"space-between"}
								alignItems={"center"}
								paddingLeft={20}
								paddingRight={20}
								paddingTop={10}
								paddingBottom={10}
								borderBottom={"default"}
							>
								<Badge
									width={90}
									color={index % 2 === 0 ? "yellow" : "purple"}
									isSolid
								>
									{pricing["startDay"] === pricing["endDay"]
										? pricing["startDay"].slice(0, 3)
										: `${pricing["startDay"].slice(0, 3)} - ${pricing[
												"endDay"
										  ].slice(0, 3)}`}
								</Badge>	
								<EditIcon 
									color="muted"
									onClick={() => editPrice(true, pricing, pricingType)}
								/>
							</Pane>
						)}

						{pricing["priceSlots"].map((priceSlot, index) => (
							<Pane display={"flex"} flexDirection={"column"}>
								{pricingType.toUpperCase() === "HOLIDAY" ? (	
									<EditIcon 
										alignSelf="flex-end"
										color="muted"
										marginTop={5}
										marginRight={20}
										onClick={() => editPrice(true, pricing, pricingType)}
									/>
								) : null}
								<Pane
									key={index}
									display={"flex"}
									justifyContent={"space-between"}
									alignItems={"center"}
									borderBottom={
										index !== pricing["priceSlots"].length - 1
											? "default"
											: null
									}
									paddingLeft={20}
									paddingRight={20}
									paddingTop={5}
									paddingBottom={5}
								>
									<Strong>
										{`${getFormattedTime(priceSlot["startTime"])} -
                                                ${getFormattedTime(
																									priceSlot["endTime"]
																								)}`}
									</Strong>
									<Strong>{`${getCurrency()} ${
										priceSlot["pricingAmount"]
									}`}</Strong>
								</Pane>
							</Pane>
						))}
					</Pane>
				))}
			</Pane>
		</Pane>
	);
};

export default PriceSlotsPane;
